<div style="width: 25px;height: 25px;float: right;position: relative;top: -14px;right: -10px;cursor: pointer;"
     (click)="closeModal()">
    <i class="material-icons icon" style="font-size: 30px;color: #c80000">
        cancel
    </i>
</div>
<mat-dialog-content>
    <form>
        <!-- -->
        <!--<div class="form-group" *ngIf="lookupForCurrentAbsence.attribute5 != null">-->
        <div class="form-group">
            <input type="file" #myFile placeholder="Dosya yükle" (change)="fileProgress($event)">
            <div *ngIf="fileUploadProgress">
                <span style="font-weight: bold;">Yükleniyor:</span> {{ fileUploadProgress }}
            </div>
            <div style="margin-top: 5px">
                <button class="btn btn-light" [disabled]="!fileData"  (click)="uploadFile()">Yükle</button>
            </div>
            <div style="margin-top: 5px" *ngFor="let file of fileList;let i = index;">
                <div class="filename-wrapper" *ngIf="!file.willBeDeleted">
                    <a style="width: 100px;max-width: 100px;">
                        {{file.fileName}}
                    </a>
                    <i class="material-icons icon" style="color: #c80000;margin-left: 5px;cursor: pointer" (click)="deleteFile(i)">
                        delete
                    </i>
                </div>
            </div>
        </div>
        <!-- -->

        <button type="button" class="btn btn-primary" style="margin-right: 10px;" (click)="approveAbsence()">
           Onayla
        </button>
        <button type="button" class="btn btn-light" (click)="closeModal()">İptal</button>
    </form>
</mat-dialog-content>